import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * `clsx` + `tailwind-merge` — rugalmas conditional className mergeolás
 * úgy, hogy a Tailwind utility-ek nem ütköznek egymással.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
